"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = Share;

var _Popover2 = _interopRequireDefault(require("@material-ui/core/Popover"));

var _List2 = _interopRequireDefault(require("@material-ui/core/List"));

var _ListItem2 = _interopRequireDefault(require("@material-ui/core/ListItem"));

var _ListItemText2 = _interopRequireDefault(require("@material-ui/core/ListItemText"));

var _ListItemIcon2 = _interopRequireDefault(require("@material-ui/core/ListItemIcon"));

var _LinkRounded2 = _interopRequireDefault(require("@material-ui/icons/LinkRounded"));

var _CircularProgress2 = _interopRequireDefault(require("@material-ui/core/CircularProgress"));

var _CloseRounded2 = _interopRequireDefault(require("@material-ui/icons/CloseRounded"));

var _CodeRounded2 = _interopRequireDefault(require("@material-ui/icons/CodeRounded"));

var _Box2 = _interopRequireDefault(require("@material-ui/core/Box"));

var _TextField2 = _interopRequireDefault(require("@material-ui/core/TextField"));

var _IconButton2 = _interopRequireDefault(require("@material-ui/core/IconButton"));

var _Typography2 = _interopRequireDefault(require("@material-ui/core/Typography"));

var _LaunchRounded2 = _interopRequireDefault(require("@material-ui/icons/LaunchRounded"));

var _styles = require("@material-ui/core/styles");

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireWildcard(require("react"));

var _Button = _interopRequireDefault(require("../components/Button"));

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

var useStyles = (0, _styles.makeStyles)(function () {
  return {
    container: {
      width: 440,
      minHeight: 108
    },
    search: {
      borderBottom: "2px solid rgb(0 0 0 / 5%)"
    },
    list: {
      maxHeight: "70vh",
      overflow: "auto"
    },
    button: {
      backgroundColor: "#f3f4f6"
    },
    icon: {
      marginRight: 4,
      fontSize: 18
    },
    iconType: {
      fontSize: 34
    }
  };
});
Share.propTypes = {
  fields: _propTypes["default"].arrayOf(_propTypes["default"].shape({
    name: _propTypes["default"].string,
    type: _propTypes["default"].string,
    options: _propTypes["default"].object
  })),
  value: _propTypes["default"].object,
  onChange: _propTypes["default"].func,
  isLoading: _propTypes["default"].bool
};
Share.defaultProps = {
  value: {},
  onChange: function onChange() {}
};

function Share(_ref) {
  var value = _ref.value,
      isLoading = _ref.isLoading,
      onChange = _ref.onChange;
  var classes = useStyles();

  var _useState = (0, _react.useState)(),
      _useState2 = _slicedToArray(_useState, 2),
      anchorEl = _useState2[0],
      setAnchorEl = _useState2[1];

  var handleClick = function handleClick(event) {
    setAnchorEl(event.currentTarget);
  };

  var handleClose = function handleClose() {
    setAnchorEl(null);
  };

  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_Button["default"], {
    style: value !== null && value !== void 0 && value.shareUrl ? {
      backgroundColor: "#d0f0fd"
    } : {},
    onClick: handleClick,
    size: "small"
  }, /*#__PURE__*/_react["default"].createElement(_LaunchRounded2["default"], {
    className: classes.icon
  }), "Share"), /*#__PURE__*/_react["default"].createElement(_Popover2["default"], {
    anchorEl: anchorEl,
    open: Boolean(anchorEl),
    onClose: handleClose,
    anchorOrigin: {
      vertical: "bottom",
      horizontal: "left"
    },
    transformOrigin: {
      vertical: "top",
      horizontal: "left"
    }
  }, /*#__PURE__*/_react["default"].createElement(_Box2["default"], {
    className: classes.container
  }, value !== null && value !== void 0 && value.shareUrl ? /*#__PURE__*/_react["default"].createElement(_Box2["default"], {
    p: 2
  }, /*#__PURE__*/_react["default"].createElement(_Typography2["default"], {
    variant: "h6"
  }, "This view is shared via a private link"), /*#__PURE__*/_react["default"].createElement(_Typography2["default"], {
    variant: "body2",
    color: "textSecondary"
  }, "People with the private link can only see cells visible in this view."), /*#__PURE__*/_react["default"].createElement(_Box2["default"], {
    my: 1
  }, /*#__PURE__*/_react["default"].createElement(_TextField2["default"], {
    fullWidth: true,
    value: value.shareUrl,
    variant: "outlined",
    size: "small",
    InputProps: {
      style: {
        fontSize: 14
      },
      endAdornment: /*#__PURE__*/_react["default"].createElement(_IconButton2["default"], {
        onClick: function onClick() {
          return window.open(value.shareUrl, "_blank");
        },
        size: "small"
      }, /*#__PURE__*/_react["default"].createElement(_LaunchRounded2["default"], {
        fontSize: "small"
      }))
    }
  })), value.embedUrl && /*#__PURE__*/_react["default"].createElement(_Box2["default"], null, /*#__PURE__*/_react["default"].createElement(_Button["default"], {
    onClick: function onClick() {
      return window.open(value.embedUrl, "_blank");
    },
    startIcon: /*#__PURE__*/_react["default"].createElement(_CodeRounded2["default"], {
      fontSize: "small"
    })
  }, "Embed this view on your site")), /*#__PURE__*/_react["default"].createElement(_Box2["default"], null, /*#__PURE__*/_react["default"].createElement(_Button["default"], {
    onClick: function onClick() {
      return onChange("remove");
    },
    startIcon: /*#__PURE__*/_react["default"].createElement(_CloseRounded2["default"], {
      fontSize: "small"
    })
  }, "Disabled shared view link"))) : /*#__PURE__*/_react["default"].createElement(_List2["default"], null, /*#__PURE__*/_react["default"].createElement(_ListItem2["default"], {
    onClick: function onClick() {
      return onChange("create");
    },
    button: true
  }, /*#__PURE__*/_react["default"].createElement(_ListItemIcon2["default"], null, isLoading ? /*#__PURE__*/_react["default"].createElement(_CircularProgress2["default"], null) : /*#__PURE__*/_react["default"].createElement(_LinkRounded2["default"], {
    color: "primary",
    className: classes.iconType
  })), /*#__PURE__*/_react["default"].createElement(_ListItemText2["default"], {
    primary: "Create a shareable view link",
    secondary: "You can send the link to anyone or embed it on a website"
  }))))));
}